import React from 'react';
import { ebooks } from '../mock';
import { useCart } from '../context/CartContext';
import { Check, ShoppingCart } from 'lucide-react';
import { toast } from 'sonner';

const Products = () => {
  const { addToCart } = useCart();

  const handleAddToCart = (ebook) => {
    const added = addToCart(ebook);
    if (added) {
      toast.success(`${ebook.title} adicionado ao carrinho!`);
    } else {
      toast.info('Este e-book já está no carrinho');
    }
  };

  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh', paddingTop: '120px', paddingBottom: '64px' }}>
      <div className="container">
        <h1 className="display-medium" style={{ textAlign: 'center', marginBottom: '16px' }}>
          Nossos Programas de Treinamento
        </h1>
        <p className="body-large" style={{ textAlign: 'center', marginBottom: '48px', color: 'var(--text-secondary)' }}>
          Escolha o programa ideal para seus objetivos
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
          gap: '48px',
          maxWidth: '1200px',
          margin: '0 auto'
        }}>
          {ebooks.map(ebook => (
            <div key={ebook.id} className="network-card" style={{ padding: '0', overflow: 'hidden' }}>
              <div style={{ position: 'relative' }}>
                <img 
                  src={ebook.image} 
                  alt={ebook.title}
                  style={{ width: '100%', height: '300px', objectFit: 'cover' }}
                />
                <div style={{
                  position: 'absolute',
                  top: '16px',
                  right: '16px',
                  background: 'var(--brand-primary)',
                  color: 'var(--brand-dark)',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontWeight: '700',
                  fontSize: '14px'
                }}>
                  {ebook.duration}
                </div>
              </div>
              
              <div style={{ padding: '32px' }}>
                <p className="caption" style={{ color: 'var(--brand-dark)', fontWeight: '600', marginBottom: '8px' }}>
                  {ebook.target}
                </p>
                <h2 className="heading-2" style={{ marginBottom: '8px' }}>
                  {ebook.title}
                </h2>
                <p className="body-small" style={{ marginBottom: '4px', color: 'var(--text-light)' }}>
                  {ebook.subtitle}
                </p>
                <p className="body-medium" style={{ marginBottom: '24px', marginTop: '12px' }}>
                  {ebook.description}
                </p>

                <div style={{ 
                  background: 'var(--bg-subtle)', 
                  padding: '20px', 
                  borderRadius: '16px',
                  marginBottom: '24px'
                }}>
                  <h4 className="heading-3" style={{ marginBottom: '16px', fontSize: '18px' }}>
                    O que está incluído:
                  </h4>
                  {ebook.features.map((feature, idx) => (
                    <div key={idx} style={{ 
                      display: 'flex', 
                      gap: '12px', 
                      marginBottom: '12px',
                      alignItems: 'flex-start'
                    }}>
                      <Check size={20} color="var(--brand-dark)" style={{ flexShrink: 0, marginTop: '2px' }} />
                      <span className="body-small">{feature}</span>
                    </div>
                  ))}
                </div>

                <div style={{
                  background: 'var(--bg-card)',
                  padding: '20px',
                  borderRadius: '16px',
                  marginBottom: '24px'
                }}>
                  <h4 className="heading-3" style={{ marginBottom: '12px', fontSize: '18px' }}>
                    Benefícios:
                  </h4>
                  {ebook.benefits.map((benefit, idx) => (
                    <div key={idx} style={{ 
                      display: 'flex', 
                      gap: '12px', 
                      marginBottom: '8px',
                      alignItems: 'flex-start'
                    }}>
                      <Check size={18} color="var(--brand-dark)" style={{ flexShrink: 0, marginTop: '2px' }} />
                      <span className="body-small">{benefit}</span>
                    </div>
                  ))}
                </div>

                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '24px',
                  borderTop: '2px solid var(--border-light)'
                }}>
                  <div>
                    <p className="caption" style={{ marginBottom: '4px' }}>Investimento</p>
                    <p className="display-small" style={{ color: 'var(--brand-dark)' }}>
                      R$ {ebook.price.toFixed(2)}
                    </p>
                  </div>
                  <button 
                    className="btn-cta"
                    onClick={() => handleAddToCart(ebook)}
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    <ShoppingCart size={20} />
                    Adicionar ao Carrinho
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;